import React, { useEffect, useState } from "react";
import apiClient from "../../../shared/API/apiClient";
import { useReportingYear } from "../../../context/ReportingYearContext";
import { useLocation } from "react-router-dom";
import MatrixTable from "../../../features/disclouser/sectionB/MatrixTable";
import GovernanceBlock from "../../../features/disclouser/sectionB/GovernanceBlock";
import PerformanceBlock from "../../../features/disclouser/sectionB/PerformanceBlock";
import Toast from "../../../shared/components/Toast";
import usePermission from "../../../shared/hooks/usePermission";

export default function SectionBForm() {

  const { hasPermission } = usePermission();
const canView =
  hasPermission(
    "process-disclosures",
    "view"
  );
const canCreate =
  hasPermission(
    "process-disclosures",
    "create"
  );
  const location = useLocation();

  const {
    reportingYear,
    reportingYearId
  } = useReportingYear();

  const [schema, setSchema] = useState(null);
  const [legalEntities, setLegalEntities] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState("");
  const [loading, setLoading] = useState(false);
  const [toast, setToast] =useState(null);

  const [responses, setResponses] = useState({
    matrix: {},
    text: {},
    table: {}
  });

  const [isReadOnly, setIsReadOnly] = useState(!canCreate);

  useEffect(() => {
    if (!canView) return;
    loadSchema();
  }, [canView]);

useEffect(() => {
  if (!canView) return;
  if (!reportingYearId) return;

  apiClient.get("/api/legal-entities-by-year", {
    params: { reporting_year_id: reportingYearId }
  }).then(res => {
    setLegalEntities(res.data.data || []);
    setSelectedEntity("");
  });
}, [canView,reportingYearId]);

useEffect(() => {

  if (!canView) return;

  if (
    reportingYearId &&
    selectedEntity
  ) {

    loadResponses();

  }

}, [canView,
  reportingYearId,
  selectedEntity
]);
  const loadSchema = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get("/api/section-b/schema");
      setSchema(res.data);
    } finally {
      setLoading(false);
    }
  };

  const loadResponses = async () => {

  if (
    !reportingYearId ||
    !selectedEntity
  ) {
    return;
  }

  try {

    const res =
      await apiClient.get(
        "/api/section-b",
        {
          params: {
            reporting_year_id:
              reportingYearId,

            legal_entity_id:
              selectedEntity
          }
        }
      );

    //console.log("Section B API Response",res.data);
    

      if (res?.data?.responses) {

  setResponses(
    res.data.responses
  );

        setIsReadOnly(!canCreate ||
          res.data.submission_status ===
          "submitted"
        );

      }

  } catch (error) {

    console.error(
      "Failed to load responses",
      error
    );

  }

};
// =========================================
  // TOAST
  // =========================================

  const showToast = (
    message,
    type = "success"
  ) => {

    setToast({
      message,
      type
    });
  };

  const updateMatrix = (questionCode, principleCode, value) => {
    setResponses(prev => ({
      ...prev,
      matrix: {
        ...prev.matrix,
        [questionCode]: {
          ...(prev.matrix[questionCode] || {}),
          [principleCode]: value
        }
      }
    }));
  };

  const updateText = (
  questionCode,
  value,
  field = null
) => {

  if (!field) {
    setResponses(prev => ({
      ...prev,
      text: {
        ...prev.text,
        [questionCode]: value
      }
    }));
    return;
  }

  setResponses(prev => ({
    ...prev,
    text: {
      ...prev.text,

      [questionCode]: {
        ...(prev.text?.[questionCode] || {}),
        [field]: value
      }
    }
  }));
};

 const validateSubmit = () => {

  const errors = [];

  // Q7

  if (
    !responses?.text?.Q7?.trim()
  ) {

    errors.push(
      "Q7 is required"
    );

  }

  // Q8

  if (
    !responses?.text?.Q8?.trim()
  ) {

    errors.push(
      "Q8 is required"
    );

  }

  // Q9

  if (
    !responses?.text?.Q9?.answer
  ) {

    errors.push(
      "Q9 selection is required"
    );

  } else if (

    responses?.text?.Q9?.answer === "Yes" &&

    !responses?.text?.Q9?.details?.trim()

  ) {

    errors.push(
      "Q9 details are required"
    );

  }

  const q1a =
  responses?.matrix?.Q1A || {};

Object.entries(q1a).forEach(
  ([principleCode, value]) => {

    if (value !== "Yes") {

      const q12 =
        responses?.table?.Q12?.[
          principleCode
        ] || {};

      if (
        !q12.reason?.trim() &&
        !q12.otherReason?.trim()
      ) {

        errors.push(
          `Q12 reason required for ${principleCode}`
        );

      }

    }

  }
);

  return errors;
};

const buildPayload = () => {

  const finalResponses = {
    matrix: {},
    text: {},
    table: {}
  };

  (schema?.blocks || []).forEach(
    (block) => {

      (block.questions || []).forEach(
        (question) => {

          // ==========================
          // Q9 SPECIAL CASE
          // ==========================

          if (
            question.question_code === "Q9"
          ) {

            finalResponses.text.Q9 =
              responses?.text?.Q9 || {
                answer: "",
                details: ""
              };

            return;
          }

          // ==========================
          // MATRIX QUESTIONS
          // ==========================

          if (
            question.question_type ===
              "matrix_boolean" ||
            question.question_type ===
              "matrix_text"
          ) {

            finalResponses.matrix[
              question.question_code
            ] = {};

            (schema?.principles || [])
              .forEach((p) => {

                finalResponses.matrix[
                  question.question_code
                ][p.principle_code] =

                  responses?.matrix?.[
                    question.question_code
                  ]?.[
                    p.principle_code
                  ] ?? "";

              });

            return;
          }

          // ==========================
          // TEXT QUESTIONS
          // ==========================

          if (
            question.question_type ===
            "text"
          ) {

            finalResponses.text[
              question.question_code
            ] =
              responses?.text?.[
                question.question_code
              ] ?? "";

            return;
          }

          // ==========================
          // TABLE QUESTIONS
          // ==========================

          if (
            question.question_type ===
            "table"
          ) {

            finalResponses.table[
              question.question_code
            ] =
              responses?.table?.[
                question.question_code
              ] ?? {};

          }

        }
      );

    }
  );

  return finalResponses;
};

const saveSectionB = async (mode) => {

  if (!canCreate) {
    return;
  }

  // VALIDATE BEFORE API CALL

  if (mode === "submitted") {

    const errors =
      validateSubmit();

    if (errors.length > 0) {

      showToast(
        errors[0],
        "error"
      );

      return;
    }
    
  }

  try {

    const payload = {
      reporting_year_id:
        reportingYearId,

      legal_entity_id:
        selectedEntity,

      mode,

      responses:
        buildPayload()
    };

    const res =
      await apiClient.post(
        "/api/section-b/save",
        payload
      );

    if (res.data.success) {

      showToast(
        mode === "draft"
          ? "Draft Saved"
          : "Submitted Successfully",
        "success"
      );

      if (
        mode === "submitted"
      ) {

        setTimeout(() => {

          window.location.reload();

        }, 1500);

      }

    }

  } catch (error) {

    showToast(
      error?.response?.data?.message ||
      "Unable to save",
      "error"
    );

  }

};

if (!canView) {
  return (
    <div className="dash-page">
      <div className="empty-entity">
        <div className="empty-entity__icon">
          <i className="fa-solid fa-lock" />
        </div>

        <div className="empty-entity__title">
          Access Restricted
        </div>

        <div className="empty-entity__sub">
          You do not have permission to access this disclosure section.
        </div>
      </div>
    </div>
  );
}
  if (loading) return <div>Loading...</div>;
  if (!schema) return null;

  return (
    <div className="dash-page">
      <h1>Section B - Management & Process Disclosures</h1>

      <div className="filter-card">
        <div className="filter-group">
          <label>Reporting Year</label>
          <input className="filter-input" value={reportingYear || ""} disabled />
        </div>

        <div className="filter-group">
          <label>Legal Entity</label>
          <select className="filter-input" value={selectedEntity} onChange={(e) => setSelectedEntity(e.target.value)}>
                <option value="">Select</option>

                {legalEntities.map((entity) => (
                  <option
                    key={entity.entity_id}
                    value={entity.entity_id}
                  >
                    {entity.entity_name}
                  </option>
                ))}
          </select>
        </div>
      </div>
      {!selectedEntity && (
  <div className="st-empty-entity">
    <div className="st-empty-entity__icon">
      <i className="fa-solid fa-building" />
    </div>

    <div className="st-empty-entity__title">
      Select a Legal Entity to continue
    </div>

    <div className="st-empty-entity__sub">
      Select a legal entity above to track disclosure progress across all BRSR Principles and take required actions.
    </div>
  </div>
)}
      {selectedEntity && (
  <>
{isReadOnly && (

  <div class="bms-info-bar">
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye" aria-hidden="true">
  <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle></svg>
  <span>
  <strong>Section B is a read-only consolidation.</strong></span></div>
)}
{!isReadOnly && (
<div
            className="draft-box"
            
          >
            ✏️ Draft — Editable
          </div>
          )}
          {(schema?.blocks || []).map((block) => {

  if (block.block_code === "POLICY") {
    return (
      <MatrixTable
        key={block.block_code}
        block={block}
        principles={schema.principles || []}
        responses={responses}
        updateMatrix={updateMatrix}
        showToast={showToast}
        isReadOnly={isReadOnly}
      />
    );
  }

  if (block.block_code === "GOVERNANCE") {
    return (
      <GovernanceBlock
        key={block.block_code}
        block={block}
        responses={responses}
        updateText={updateText}
        isReadOnly={isReadOnly}
      />
    );
  }

  if (block.block_code === "PERFORMANCE") {
    return (
      <PerformanceBlock
        key={block.block_code}
        block={block}
        principles={schema.principles || []}
        responses={responses}
        setResponses={setResponses}
        showToast={showToast}
        isReadOnly={isReadOnly}
    />
    );
  }

  return null;
})}
{!isReadOnly && (
     <div className="ecf-footer"
            style={{
              justifyContent:
                "space-between"
            }}
          >
        <div
              style={{
                display: "flex",
                gap: "12px"
              }}
            >

              <button onClick={() =>saveSectionB("draft")} type="button" className="org-btn-cancel">
               Save Draft
              </button>

              <button type="button" className="org-btn-save" onClick={() =>saveSectionB("submitted")}>
                Submit
              </button>

            </div>
      </div>
      )}
</>
)}
      {/* TOAST */}

      {toast && (

        <Toast
          message={
            toast.message
          }
          type={
            toast.type
          }
          onClose={() =>
            setToast(null)
          }
        />

      )}
    </div>
  );
}
